<div
  class="app-content"
  role="main">
  <div class="main-content-wrapper">
    <router-outlet
      style="height: 100%; width: 100%"
      id="main-content"></router-outlet>
  </div>
</div>
